export const VARIANTS_KEY = 'variants';
export const DEFAULT_TEASER_ID = 'default';
export const SEO_TEASER_ID = 'seo';
export const SOCIAL_TEASER_ID = 'opengraph';
export const TEASER_VERSION_A_ID = 'a';
export const TEASER_VERSION_B_ID = 'b';
export const CREATE_AB_TEST_ID = 'createAbTest';
